import { type ImgHTMLAttributes } from 'react';

type ImgWithFallbackProps = {
  src: string;
  fallback: string;
  type?: string;
} & ImgHTMLAttributes<HTMLImageElement>;

export const ImgWithFallback = ({
  src,
  fallback,
  type = 'image/webp',

  ...delegated
}: ImgWithFallbackProps) => {
  return (
    <picture>
      <source srcSet={src} type={type} />
      <img src={fallback} {...delegated} />
    </picture>
  );
};
